import { createReducer, on } from '@ngrx/store';
import {
  login,
  loginSuccess,
  loginFailure,
  loginShowPassword,
  loginVerify2FACodeFailure
} from './login.actions';
import { Verify2FAError } from '@app/auth/routes/login/state/login.model';

export interface State {
  readonly loginError?: string;
  readonly verify2FAError?: Verify2FAError;
  readonly pending: boolean;
  readonly showPasswordField: boolean;
  readonly attemptsLeft?: number;
  readonly bannedTime?: number;
}

export const initialState: State = {
  pending: false,
  showPasswordField: false,
};

export const reducer = createReducer(
  initialState,

  on(login, (state) => ({
    ...state,
    loginError: undefined,
    pending: true,
  })),

  on(loginSuccess, (state) => ({
    ...state,
    loginError: undefined,
    attemptsLeft: undefined,
    bannedTime: undefined,
    pending: false,
  })),

  on(loginFailure, (state, { payload }) => ({
    ...state,
    loginError: payload.error,
    attemptsLeft: payload.attemptsLeft,
    bannedTime: payload.bannedTime,
    pending: false,
  })),

  on(loginShowPassword, (state) => ({
    ...state,
    showPasswordField: true,
  })),

  on(loginVerify2FACodeFailure, (state, { payload }) => ({
    ...state,
    verify2FAError: payload,
  }))
);

export const getLoginError = (state: State) => {
  return state.loginError;
};
export const getVerify2FAError = (state: State) => {
  return state.verify2FAError;
};
export const getPending = (state: State) => {
  return state.pending;
};
